import { useEffect, useRef } from "react";

const usePrevious = <T>(value?: T): T | undefined => {
  const previous = useRef<T | undefined>(value);

  useEffect(() => {
    previous.current = value;
  });

  return previous.current;
};

export default usePrevious;
